import React from 'react';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';

import UserIcon from '../../../../components/UserIcon';
import colors from '../../../../styles/theme/foundation/colors';
import RequirementTemplateType from '../../../../types/RequirementTemplateType';

function StarterTemplateRow({ template }) {
  return (
    <Box
      _hover={{ cursor: 'pointer', boxShadow: 'hover' }}
      borderRadius="md"
      boxShadow="0px 6px 18px rgba(123, 150, 178, 0.12)"
      color={colors.greyScale['500']}
      height="135px"
      mb={4}
      mx="auto"
      px={5}
      py={3}
      width="95%"
    >
      <Flex justifyContent="space-between" mb={3} width="100%">
        <Text
          color={colors.greyScale['900']}
          textStyle="bodyLg600"
        >
          {template.name}
        </Text>
        <HStack>
          <Text textStyle="bodySm">Created By: </Text>
          <UserIcon
            firstName={template.creator?.userFirstName}
            fontSize="xxs"
            iconSize="24px"
            lastName={template.creator?.userLastName}
          />
        </HStack>
      </Flex>
      <Box
        overflow="hidden"
        textAlign="left"
        textOverflow="ellipsis"
        textStyle="bodyLg"
        whiteSpace="nowrap"
        width="100%"
      >
        {template.description || 'No description'}
      </Box>
    </Box>
  );
}

StarterTemplateRow.propTypes = { template: RequirementTemplateType };

export default StarterTemplateRow;
